<template>
  <section>
    <h2 class="h2Title">팝업 등록</h2>
    <div class="formInfo">
      <v-form ref="formPopup">
        <dl class="infoCont">
          <dt class="formInfoTxt small">제목 <i class="fa fa-asterisk" aria-hidden="true"/></dt>
          <dd class="formInfoArea">
            <v-col class="mgr" sm="6">
              <v-text-field v-model="popup.title" :rules="[rules.required]" label="" dense flat clearable/>
            </v-col>
          </dd>
        </dl>
        <dl class="infoCont">
          <dt class="formInfoTxt small">카테고리 </dt>
          <dd class="formInfoArea">
            <v-col class="mgr" sm="6">
              <v-combobox :items="popupCategoryList" item-value="value" item-text="text"
                          v-model="popup.popupCategory"
                          dense clearable flat
                          required
                          :return-object=false
                          @update:search-input="setCategory"
                          label="팝업 카테고리"/>
            </v-col>
          </dd>
        </dl>
        <dl class="infoCont">
          <dt class="formInfoTxt small">노출 여부  <i class="fa fa-asterisk" aria-hidden="true"/></dt>
          <dd class="formInfoArea">
              <v-switch
                  v-model="popup.activated"
                  flat
                  color="primary"
                  :label="popup.activated ? '노출' : '미노출'"
              ></v-switch>
          </dd>
        </dl>
        <dl class="infoCont">
          <dt class="formInfoTxt small">노출 기간 <i class="fa fa-asterisk" aria-hidden="true"/></dt>
          <dd class="formInfoArea d-flex">
              <div>
                <v-switch
                    v-model="popup.always"
                    flat
                    color="primary"
                    class="custom-switch-color"
                    :label="popup.always ? '상시노출' : '기간지정'"
                ></v-switch>
              </div>
              <div v-if="!popup.always" class="d-flex" style="padding-left: 10px">
                  <v-menu
                      v-model="startCal"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="popup.startDt"
                          label="노출 시작일"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          :rules="[rules.required]"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="popup.startDt"
                        @input="startCal = false"
                    ></v-date-picker>
                  </v-menu>
                  <vue-timepicker manual-input v-model="popup.startTm" :input-class="errStartTm ? 'invalid' : ''" style="margin-top: 25px"></vue-timepicker>
                  <v-input hidden v-model="popup.startTm"></v-input>

                  <div style="margin-top: 25px; padding-left: 10px; padding-right: 10px">~</div>

                  <v-menu
                      v-model="endCal"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="popup.endDt"
                          label="노출 종료일"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          :rules="[rules.required]"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="popup.endDt"
                        @input="endCal = false"
                    ></v-date-picker>
                  </v-menu>
                  <vue-timepicker manual-input v-model="popup.endTm" :input-class="errEndTm ? 'invalid' : ''"  style="margin-top: 25px"></vue-timepicker>
                  <v-input hidden v-model="popup.endTm"></v-input>

              </div>
          </dd>
        </dl>
        <dl class="infoCont">
          <dt class="formInfoTxt small">위치 <i class="fa fa-asterisk" aria-hidden="true"/></dt>
          <dd class="formInfoArea">
            <v-col class="mgr d-flex" sm="6">
              <v-text-field type="number" v-model="popup.positionLeft" label="좌측 위치" :rules="[rules.required, rules.maxNumber]" dense flat clearable/> <div style="margin-top: 22px">px</div>
              <v-spacer></v-spacer>
              <v-text-field type="number" v-model="popup.positionTop" label="상단 위치" :rules="[rules.required, rules.maxNumber]" dense flat clearable/> <div style="margin-top: 22px">px</div>
            </v-col>
          </dd>
        </dl>
        <dl class="infoCont">
          <dt class="formInfoTxt small">크기 <i class="fa fa-asterisk" aria-hidden="true"/></dt>
          <dd class="formInfoArea">
            <v-col class="mgr d-flex" sm="6">
              <v-text-field type="number" v-model="popup.sizeWidth" label="넓이" :rules="[rules.required, rules.maxNumber]" dense flat clearable/> <div style="margin-top: 22px">px</div>
              <v-spacer></v-spacer>
              <v-text-field type="number" v-model="popup.sizeHeight" label="높이" :rules="[rules.required, rules.maxNumber]" dense flat clearable/> <div style="margin-top: 22px">px</div>
            </v-col>
          </dd>
        </dl>
        <dl class="infoCont">
          <dt class="formInfoTxt small">링크 주소</dt>
          <dd class="formInfoArea">
            <v-col class="mgr d-flex" sm="6">
              <v-text-field v-model="popup.url" label="" dense flat clearable/>

              <v-switch
                  v-model="popup.urlTarget"
                  flat
                  color="primary"
                  class="custom-switch-color"
                  true-value="_blank"
                  false-value="_self"
                  :label="popup.urlTarget === '_blank' ? '새창' : '현재창'"
              ></v-switch>
            </v-col>
          </dd>
        </dl>
        <dl class="infoCont">
          <dt class="formInfoTxt small">팝업 타입</dt>
          <dd class="formInfoArea">
              <v-switch
                  v-model="popup.layer"
                  flat
                  color="primary"
                  class="custom-switch-color"
                  :label="popup.layer ? '팝업' : '레이어'"
              ></v-switch>
          </dd>
        </dl>
        <dl class="infoCont">
          <dt class="formInfoTxt small">내용</dt>
          <dd class="formInfoArea">
            <v-col class="mgr" sm="8">
              <editor-component
                  ref="popupContents"
                  :val="popup.contents"
                  :uploaded="fileMeta"
                  @callback-upload="uploadImage"
                  label="팝업 내용"/>
            </v-col>
          </dd>
        </dl>
      </v-form>
    </div>
    <div class="btnStyleBx">
      <div class="btnCommon justify-center">
        <v-btn class="vBtn" color="#1991eb" dark @click="save">
          <v-icon left>mdi mdi-content-save</v-icon>
          저장
        </v-btn>
        <v-btn class="vBtn" color="#fafafa" @click="goList">
          <v-icon left>mdi mdi-format-list-bulleted</v-icon>
          목록
        </v-btn>
      </div>
    </div>
  </section>

</template>

<script>
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'

import EditorComponent from "@/views/component/EditorComponent";

import popupApi from "@/api/PopupApi";

export default {
  name: "PopupForm",
  components: {
    'editor-component': EditorComponent,
    VueTimepicker
  },
  data: () => ({
    title: '팝업 추가',
    popup: {
      urlTarget:'_blank'
    },
    startCal: false,
    endCal: false,
    errStartTm:false,
    errEndTm:false,
    rules: {
      required: value => !!value || '필수 입력 항목입니다..',
      maxNumber: value => value && value < 2560 && value > 10  || '허용되지 않는 범위입니다.'
    },
    editorOptions:{},
    options:{},
    popupTypeItems: [
      {
        value: 'L',
        text: '레이어'
      },
      {
        value: 'P',
        text: '팝업'
      }
    ],
    fileMeta:{},
    editorMode:true,
    popupCategoryList: [],
  }),
  methods: {
    async save() {
      if(!await this.$refs.formPopup.validate())
        return;

      if(this.popup.startTm && typeof this.popup.startTm === "object") {
        this.popup.startTm = this.popup.startTm.HH + ":" + this.popup.startTm.mm + ":00"
      }
      if(this.popup.endTm && typeof this.popup.endTm === "object") {
        this.popup.endTm = this.popup.endTm.HH + ":" + this.popup.endTm.mm + ":00"
      }
      this.popup.contents = this.$refs.popupContents.getValue();

      // console.log(this.popup)
      popupApi.save(this.popup).then(data => {
        if (data) {
          if (this.popup.popupId) {
            alert("수정되었습니다.");
          } else {
            alert("등록되었습니다.");
          }
          this.goList();
        } else {
          alert("Error");
        }
      });
    },
    goList() {
      this.$router.push({path: `/popup`})
    },
    setCategory(v) {
      if(v)
        this.popup.popupCategory = v;
    },
    uploadImage(f) {
      popupApi.uploadImage(f).then(res => {
        this.fileMeta = res;
      });
    },
  },
  created() {
    if (this.$route.params.popupId) {
      popupApi.get(this.$route.params.popupId).then(data => {
        // console.log(data);
        this.popup = data;
      });
    }

    this.popup.popupCategory = this.$route.params.popupCategory;
    popupApi.getCategory().then(data => {
      const { length } = data;
      let categories = [];
      if (length > 0) categories = data.map(c => ({ value: c, text: c }))
      categories = [{ value: 'main', text: 'main' }];
      this.popupCategoryList = categories;
    })
  }

}
</script>

<style lang="scss">

.custom-switch-color:not(.v-input--is-label-active) .v-input--selection-controls__input div {
  color: olivedrab !important;
}

</style>